import { toast as baseToast } from "@/components/hooks/use-toast";

/**
 * Generate a snaplandId from an i18n key
 * Example: 'dashboard.builder.saveTemplateSuccess' -> 'toast-dashboard-builder-save-template-success'
 */
function generateSnaplandId(i18nKey: string, variant: string): string {
  // Convert dot notation to kebab-case
  const kebabKey = i18nKey.replace(/\./g, "-").toLowerCase();
  return `toast-${kebabKey}-${variant}`;
}

/**
 * Simplified toast API with green/red background colors
 * for success and error states.
 *
 * The snaplandId is ALWAYS auto-generated from the titleKey.
 * This ensures consistent naming and tracking across the application.
 *
 * @param titleKey - Translated title string (the i18n key is extracted to generate snaplandId)
 * @param descriptionKey - Optional translated description string
 */
export const snaplandToast = {
  success: (titleKey: string, descriptionKey?: string) => {
    baseToast({
      title: titleKey,
      description: descriptionKey,
      variant: "success",
      snaplandId: generateSnaplandId(titleKey, "success"),
    });
  },

  error: (titleKey: string, descriptionKey?: string) => {
    baseToast({
      title: titleKey,
      description: descriptionKey,
      variant: "destructive",
      snaplandId: generateSnaplandId(titleKey, "error"),
    });
  },

  info: (titleKey: string, descriptionKey?: string) => {
    baseToast({
      title: titleKey,
      description: descriptionKey,
      variant: "info",
      snaplandId: generateSnaplandId(titleKey, "info"),
    });
  },

  warning: (titleKey: string, descriptionKey?: string) => {
    baseToast({
      title: titleKey,
      description: descriptionKey,
      variant: "warning",
      snaplandId: generateSnaplandId(titleKey, "warning"),
    });
  },
};
